import { IPublicClientApplication, RedirectRequest } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { Location } from 'react-router-dom';
import { loginRequest } from '..';
import { saveEmailToStorage } from '../lib/EmailStorage';
import { useSaveLocation } from './UseSaveLocation.hook';

/**
 * Provides use of email based login flow with MSAL.
 * @param email Email address of user to login
 */
export function useEmailLogin(): {
  login: (email: string, redirectTo: Location, authority?: string) => void;
} {
  const { instance } = useMsal();
  const [, saveLocation] = useSaveLocation();
  const login = (email: string, redirectTo: Location, authority?: string) => {
    saveEmailToStorage(email);
    saveLocation(redirectTo);
    loginEmailWithMSAL(email, instance, authority);
  };
  return {
    login,
  };
}

/**
 *
 * @param email email of user
 * @param msal MSAL instance
 * @param authority optional B2C authority URL to use for login
 */
export function loginEmailWithMSAL(
  email: string,
  msal: IPublicClientApplication,
  authority?: string
) {
  const domain = email.substring(email.lastIndexOf('@') + 1);
  const request: RedirectRequest = {
    ...loginRequest,
    extraQueryParameters: {
      ...loginRequest.extraQueryParameters,
      domain_hint: domain,
    },
  };

  // Use provided authority if available
  if (authority) {
    request.authority = authority;
  }

  msal.loginRedirect(request);
}
